export enum LocalStorageKey {
  LatestCategoryNavMenu = 'LatestCategoryNavMenu',
  BestCategoryNavMenu = 'BestCategoryNavMenu',
  BestType = 'BestType',
  RankingCategoryNavMenu = 'RankingCategoryNavMenu',
  RankingType = 'RankingType',
  EpisodeOrderType = 'EpisodeOrderType',
  NoticeOrderType = 'NoticeOrderType',
  EpisodeReplyOrder = 'EpisodeReplyOrder',
  MyFavoriteContentsRefineType = 'MyFavoriteContentsRefineType',
  MyRecentContentsRefineType = 'MyRecentContentsRefineType',
  /** @deprecated TODO: [2025-09-22] Deprecated, Target App 2.17.4.1 ~ */
  MyFavoriteCategoryRefineTypes = 'MyFavoriteCategoryRefineTypes',
  MyFavoriteCategoryRefineTypeIds = 'MyFavoriteCategoryRefineTypeIds',
  ViewerTheme = 'ViewerTheme',
  ViewerFont = 'ViewerFont',
  ViewerFontSize = 'ViewerFontSize',
  ViewerLineHeight = 'ViewerLineHeight',
  ViewerParagraphIndent = 'ViewerParagraphIndent',
  ViewerPadding = 'ViewerPadding',
  ViewerIndentation = 'ViewerIndentation',
  ViewerViewType = 'ViewerViewType',
  ViewerFancyShare = 'ViewerFancyShare',
  ViewerViewTypeNoti = 'ViewerViewTypeNoti',
  InAppReviewRequestAt = 'InAppReviewRequestAt',
  ViewerFancyShareOptionGuide = 'ViewerFancyShareOptionGuide',
  ActivityPointInduceBottomModalHideTime = 'ActivityPointInduceBottomModalHideTime',
  AuthorSurveyBottomModalHideTime = 'AuthorSurveyBottomModalHideTime',
  AppInstallBottomModalHideTime = 'AppInstallBottomModalHideTime',
  FavoriteCategoryBottomModalHideTime = 'FavoriteCategoryBottomModalHideTime',
  DirittoStudioWelcomeModalHideTime = 'DirittoStudioWelcomeModalHideTime',
  ViewerPageViewIntroModalHideTime = 'ViewerPageViewIntroModalHideTime',
  RollingIntroModalHideTime = 'RollingIntroModalHideTime',
  AppInstallForPushBottomModalHideTime = 'AppInstallForPushBottomModalHideTime',
  AppPushOnBottomModalHideTime = 'AppPushOnBottomModalHideTime',
  AppPushOnBannerHideTime = 'AppPushOnBannerHideTime',
  NpsCampaignAnsweredId = 'NpsCampaignAnsweredId',
  SeedGenerateTimestamp = 'SeedGenerateTimestamp',
  HomeSectionViewMode = 'homeSectionViewMode',
  ModeGuideFABDismissed = 'modeGuideFABDismissed',

  EpisodeInfoRedDotView = 'EpisodeInfoRedDotView',
  RedDotView = 'RedDotView',
  MessageGuideTooltip = 'MessageGuideTooltip',

  // 픽앤츄
  Contests1 = 'Contest1',
  Contests2 = 'Contest2',
  Contests3 = 'Contest3',
  Contests4 = 'Contest4',
  Contests5 = 'Contest5',

  // 픽앤츄 2
  PickAndChoo2IntroModal = 'PickAndChoo2IntroModal',
  PickAndChoo2TooltipClicked = 'PickAndChoo2TooltipClicked',

  // 픽앤츄 4 - 2026
  PickAndChoo4MyStudioContentsTabClicked = 'PickAndChoo4MyStudioContentsTabClicked',
}
